module.exports = __webpack_public_path__ + "media/images/plans/plan-detail-background-wedding-point-3f31e26b26ac4a967e24ebb875e2ac05.jpg";